export const SearchTopics = {
  MaterialSearch: 'MaterialSearch',
  ProductSearch: 'ProductSearch',
  None: 'None',
} as const;

export type SearchTopic = (typeof SearchTopics)[keyof typeof SearchTopics];
